(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["truemed-widget"] && !Shopify.designMode) return;
  try {
    (function () {
    if (typeof window.ensureTruemedWidgetScript !== 'function') {
      window.ensureTruemedWidgetScript = function ensureTruemedWidgetScript() {
        if (document.getElementById('truemed-product-page-widget')) return;

        const script = document.createElement('script');
        script.id = 'truemed-product-page-widget';
        script.src = 'https://static.truemed.com/widgets/product-page-widget.min.js';
        script.defer = true;
        document.head.appendChild(script);
      };
    }

    if (typeof window.ensureTruemedScrollLock !== 'function') {
      window.ensureTruemedScrollLock = function ensureTruemedScrollLock() {
        if (window.__truemedScrollLockBound) return;
        window.__truemedScrollLockBound = true;

        let savedScrollY = 0;

        const saveScroll = () => {
          savedScrollY = window.scrollY || window.pageYOffset || 0;
        };

        const restoreScroll = () => {
          const y = savedScrollY;
          const apply = () => window.scrollTo(0, y);
          apply();
          requestAnimationFrame(apply);
          setTimeout(apply, 0);
          setTimeout(apply, 50);
        };

        document.addEventListener('click', (evt) => {
          if (evt.target.closest('.truemed-instructions-open, .truemed-entry-link')) {
            saveScroll();
            return;
          }
          if (evt.target.closest('.truemed-instructions-close, .truemed-instructions-close-button, .truemed-instructions-overlay')) {
            restoreScroll();
          }
        }, true);
      };
    }

    window.ensureTruemedWidgetScript();
    window.ensureTruemedScrollLock();
  })();
  } catch(e) { console.error(e); }
})();

})();
